import { config } from '_/config/config'
import _ from 'lodash'
import { storage } from '_/services/storage'
import i18n from '_/i18n'
const photonConfig = require('~/config/config.json')
import { api } from '_/services/api'
import { store } from '_/vuex/store'

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    /**
     * An array of fields for the selected module
     */
    relatedTableNames: {
      required: true,
      type: Array,
    },
    /**
     * An array of fields for the selected module
     */
    disabled: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * Set the component data
   *
   * @type  {Object}
   */
  data() {
    return {
      options: {},
      placeholder: i18n.t('select2.typeToSearchAndLinkEntries'),
    }
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    /**
     * select2Name getter
     *
     * @return  {string}
     */
    select2Name() {
      return `quicksearch-${Date.now()}`
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Fetches an entry by table name and id
     *
     * @param   {string}  moduleTableName
     * @param   {integer}  id
     * @return  {promise}
     */
    fetchEntry(moduleTableName, id) {
      return api
        .get(moduleTableName + '/' + id, '', [], {
          Locales: store.state.ui.localesHeaderParameter,
          Depth: '1',
        })
        .then(response => {
          return response.data.body.entry
        })
        .catch(error => {
          return null
        })
    },

    /**
     * Emmits the openReferenceSelector event
     *
     * @return  {void}
     */
    openReferenceSelector() {
      this.$emit('openReferenceSelector')
    },

    /**
     * Initializes the Select2 plugin
     *
     * @return  {void}
     */
    initializeSelect2() {
      this.options = {
        allowClear: true,
        language: {
          'Searching…': () => {
            return $(`<li class="not-found">Searching</li>`)
          },
          noResults: () => {
            return $(`<li class="not-found">${i18n.t(
              'select2.noMatchesFound'
            )}</li>
                            <li class="launch-advanced-search">
                                <span class="link" onclick="$('#${
                                  this.select2Name
                                }').trigger('openReferenceSelector')">
                                    ${i18n.t('select2.useAdvancedSearch')}
                                </span>
                            </li>`)
          },
          inputTooShort: () => {
            return $(`<li>${i18n.t(
              'select2.pleaseEnterTwoOrMoreCharacters'
            )}</li>
                            <li class="launch-advanced-search">
                                <span class="link" onclick="$('#${
                                  this.select2Name
                                }').trigger('openReferenceSelector')">
                                    ${i18n.t('select2.useAdvancedSearch')}
                                </span>
                            </li>`)
          },
        },
        placeholder: this.placeholder,
        theme: 'bootstrap',
      }

      this.setAjaxOptions()

      this.initializeSelect2Plugin()
    },

    /**
     * Selects the DOM element and binds the Select2 plugin to it
     *
     * @return  {void}
     */
    initializeSelect2Plugin() {
      const $select2 = $(this.$el).find('select')

      $select2.select2(this.options)

      const $select2Instance = $($select2).data('select2')

      $select2Instance.on('results:message', function() {
        this.dropdown._resizeDropdown()
        this.dropdown._positionDropdown()
      })

      $select2Instance.on('query', function() {
        this.dropdown._resizeDropdown()
        this.dropdown._positionDropdown()
      })

      $select2.on('change', async event => {
        const parsedValue = event.target.value.split(':')
        if (parseInt(parsedValue[1]) > 0) {
          const entry = await this.fetchEntry(
            parsedValue[0],
            parseInt(parsedValue[1])
          )
          this.$emit('closeAndInsertReference', entry)
          $select2.val(null).trigger('change')
        }
      })

      $select2.on('openReferenceSelector', () => {
        $select2.select2('close')
        this.openReferenceSelector()
      })
    },

    setAjaxOptions() {
      const self = this

      const apiToken = storage.get('apiToken')

      const itemsPerPage = photonConfig.paginatedNodesItemsPerPage

      this.options.ajax = {
        cache: true,
        data: function(term) {
          let payload = {
            filter: {
              system: {
                anchor_text: {
                  like: term.term,
                },
              },
            },
            modules: self.relatedTableNames,
            include_relations: false,
            pagination: {
              current_page: term.page || 1,
              items_per_page: itemsPerPage,
            },
          }

          return payload
        },
        dataType: 'json',
        delay: 250,
        headers: {
          Authorization: `Bearer ${apiToken}`,
        },
        processResults(data) {
          return {
            pagination: {
              more: data.body.pagination.has_more_pages,
            },
            results: data.body.entries.map(entry => {
              return {
                ...entry,
                id: `${entry.system.module.table_name}:${entry.system.id}`,
              }
            }),
          }
        },
        results(data) {
          return {
            more: true,
            results: data.body.entries.map(entry => {
              return { ...entry, id: entry.system.id }
            }),
          }
        },
        type: 'POST',
        url: config.ENV.apiBasePath + '/filter',
      }

      this.options.minimumInputLength = 2

      this.options.templateResult = function(data) {
        if (_.has(data, 'system.anchor_text')) {
          return _.get(data, 'system.anchor_text')
        }

        return data.text
      }

      this.options.templateSelection = function(data) {
        if (_.has(data, 'system.anchor_text')) {
          return _.get(data, 'system.anchor_text')
        }

        return data.text
      }
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(function() {
      this.initializeSelect2()
    })
  },

  beforeDestroy() {
    const $select2 = $(this.$el).find('select')

    if ($($select2).data('select2')) {
      $select2.select2('destroy')
    }
  },
}
